module.exports = __webpack_public_path__ + "static/media/010-slovenia.c7812a6f.svg";